export const GET_ELEMENT_MEDIA_ITEMS = "GET_ELEMENT_MEDIA_ITEMS";
export const RESET_ELEMENT_MEDIA_ITEMS = "RESET_ELEMENT_MEDIA_ITEMS";
export const SET_ELEMENT_MEDIA_ITEMS_REQUEST_STATUS = "SET_ELEMENT_MEDIA_ITEMS_REQUEST_STATUS";
